import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import WhatsAppWidget from '../../components/ui/WhatsAppWidget';
import NewsletterSubscription from '../../components/ui/NewsletterSubscription';
import HeroSection from './components/HeroSection';
import BiographySection from './components/BiographySection';
import SkillsMatrix from './components/SkillsMatrix';
import TimelineSection from './components/TimelineSection';
import AchievementBadges from './components/AchievementBadges';
import PhotoGallery from './components/PhotoGallery';
import CTASection from './components/CTASection';

const AboutMe = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>About Me - Edrian Bass | IT Engineer, Entrepreneur, Mentor & Creative Director</title>
        <meta 
          name="description" 
          content="Learn about Edrian Bass's journey as an IT Engineer, Entrepreneur, Mentor, and Creative Director. Discover his expertise in technology, business strategy, and creative direction across African markets." 
        />
        <meta 
          name="keywords" 
          content="Edrian Bass, IT Engineer, Entrepreneur, Mentor, Creative Director, Ed Pulse, Technology Expert, Business Consultant, African Tech, Nigeria, Cameroon, South Africa" 
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-20">
          <HeroSection />
          <BiographySection />
          <SkillsMatrix />
          <TimelineSection />
          <AchievementBadges />
          <PhotoGallery />
          
          <section className="py-16 lg:py-24 bg-card">
            <div className="container mx-auto px-4 md:px-6 lg:px-8">
              <div className="max-w-3xl mx-auto">
                <NewsletterSubscription />
              </div>
            </div>
          </section>

          <CTASection />
        </main>

        <WhatsAppWidget />
      </div>
    </>
  );
};

export default AboutMe;